import { User } from '@/services/types'
import { AuthGetters } from './types'

const getters: AuthGetters = {
  getAccessToken(state): string | null {
    return state.accessToken
  },
  getUser(state): User | null {
    return state.user
  },
  isShowAuthIframe(state): boolean {
    return state.isShowAuthIframe
  },
}

export default getters
